import React, { useEffect, useState } from "react";
import MuiButton from "Components/MuiButton/MuiButton";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Translator from "Languages/Utility/Translator";
import { useDispatch, useSelector } from "react-redux";
import { useSetState } from "Helpers/Hooks";
import { read } from "Helpers/LocalStorage";
import { getAllDasteProfile, getSelectColor, getType, InsertDasteProfile } from "Stores/actions";
import showNotify from "Helpers/Notify";
import { useTranslation } from 'react-i18next';
import * as Icons from 'react-bootstrap-icons';

export default function InsertNewDasteProfile({ selectedRow, onLoad, onDone }) {
    const { t } = useTranslation();
    const {
        types,
        colors,
        profileTblData,
        profileTblDataPagination,
    } = useSelector((state) => ({
        profileTblData: state.profile.profileTblData,
        profileTblDataPagination: state.profile.profileTblDataPagination,
        types: state.profile.types,
        colors: state.profile.colors,
    }));
    const dispatch = useDispatch();
    const [controls, setControls] = useSetState({
        typesList: {
        type: "select",
        selectItems: [],
        value: "",
        validation: null,
        col: 4,
        },
        colorList: {
        type: "select",
        selectItems: [],
        value: "",
        validation: null,
        col: 4,
        },
    });

    const autoCompleteHandler = async (e, value, reason) => {
        const controlName = e.target.id.split("-")[0];
        setControls({ [controlName]: { value: value } });
        if (reason === "select-option" && controlName === "typesList") {
        try {
            const paramsColor = {
            KeyUser: read("userKey"),
            KeyGroup: read("groupKey"),
            IdTypeColor: value.value,
            };
            await dispatch(getSelectColor(paramsColor));
        } catch (err) {
      console.error('[catch error]', err)
    }
        }
    }

    const onFinish = async (e) => {
        e.preventDefault();
        onLoad(true);
        const { typesList, colorList } = controls;
        if (selectedRow.key) {
            try {
                const data = {
                    KeyGroup: read("groupKey"),
                    KeyUser: read("userKey"),
                    KeyProfile: selectedRow.key,
                    IdTypeColor: +typesList.value.value,
                    IdColor: +colorList.value.value,
                };
                await dispatch(InsertDasteProfile(data));
                const params = {
                    KeyGroup: read("groupKey"),
                    KeyUser: read("userKey"),
                };
                await dispatch(getAllDasteProfile(params));
                // onDone();
            } catch (e) {
                showNotify({
                text: t('correctFormDataRequired'),
                customClass: "error",
                });
            }
        } else {
            showNotify({
                text: t('correctFormDataRequired'),
                customClass: "error",
            });
        }
        onLoad(false);
    }

    useEffect(() => {
        if (types) {
            setControls({ typesList: { value: types[0] } });
            setControls({ typesList: { selectItems: types } });
        }
    }, [types]);

    useEffect(() => {
        if (colors) {
            setControls({ colorList: { value: colors[0] } });
            setControls({ colorList: { selectItems: colors } });
        }
    }, [colors]);

    return (
        <Grid container>
            <Grid xs={12} className="mb-4">
                <span className="normalTitle">{`${t('sakht_groh_jadid')} : 
                    ${selectedRow.NameBrand} - ${selectedRow.Name} -  ${selectedRow.Struct} - 
                    ${selectedRow.Type === 'lolayi' ? t('hinged') : t('sliding')}
                `}</span>
            </Grid>
            <Grid container spacing={2}>
                {
                    Object.keys(controls).filter(key => controls[key].type === "select").map((key, index) => {
                        return (
                            <Grid item xs={12} key={key + index}>
                                <MuiAutoComplete
                                    autoSelect={true}
                                    options={controls[key].selectItems}
                                    label={<Translator id={key} />}
                                    value={controls[key].value}
                                    id={key}
                                    onChange={autoCompleteHandler}
                                />
                            </Grid>
                        )
                    })
                }
                <Grid item xs={12}>
                    <MuiButton
                        color="primary"
                        onClick={onFinish}
                        title={<Translator id="button_save" />}
                        className="w-100"
                        fullwidthOnSm
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}